import { Divider } from "@mui/material";
import { useTranslation } from "react-i18next";
import { Box, NavLink } from "../../common/components";
import { LeftSideBar } from "../../common/components/LeftSideBar";
import { OverlayScrollbarWrapper } from "../../common/components/OverlayScrollbar";
import { useSelector } from "../../common/hooks/useSelector";
import { ROUTES } from "../../constant/common.constant";
import { AddTeamNavItem } from "./AddTeamNavItem";
import cssStyles from "./LeftNavigation.module.scss";
import { SearchTeams } from "./SearchTeams";
import { TeamProjects } from "./TeamProjects";
import { createStyles } from "../../styles/theme";
import useExternalRoute from "../../utils/useExternalRoute";

const styles = createStyles({
  link: {
    paddingRight: "12px",
  },
});

export const LeftNavigation = () => {
  const userInfos = useSelector((state) => state.userInfo);
  const { t } = useTranslation();
  const { TRANSLATED_EXTERNAL_ROUTE } = useExternalRoute();

  return (
    <LeftSideBar>
      <Box className={cssStyles.container}>
        <NavLink
          to={ROUTES.HOME}
          startIcon={"home"}
          content={t("navigation.home")}
          style={styles.link}
        />

        <NavLink
          to={ROUTES.TEMPLATES}
          startIcon={"web_traffic"}
          content={t("navigation.templates")}
          style={styles.link}
        />
        <NavLink
          to={TRANSLATED_EXTERNAL_ROUTE.WORK_WITH_DESIGNER}
          startIcon={"palette"}
          content={t("navigation.work_with_designer")}
          style={styles.link}
          target="_blank"
        />

        {userInfos && (userInfos.isAdmin || userInfos.isDesigner) && (
          <SearchTeams />
        )}

        {userInfos.canAddTeam && <AddTeamNavItem />}

        <Divider sx={{ my: "8px !important" }} />

        <OverlayScrollbarWrapper style={{ marginBottom: "48px" }}>
          <div className={cssStyles.teams} data-test="teamProjects.container">
            <TeamProjects canAddProject={userInfos.canAddProject} />
          </div>
        </OverlayScrollbarWrapper>
      </Box>
    </LeftSideBar>
  );
};
